export const SCHEDULE_DATA_TABLE_PAGE_SIZE = 20;